import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface CartItem {
  productID: string;
  quantity: number;
  value: number;
}

export interface GuestCartState {
  items: CartItem[];
}

export const createGuestCartInitialState = (): GuestCartState => ({
  items: [],
});

const initialState: GuestCartState = createGuestCartInitialState();

const guestCartSlice = createSlice({
  name: "guestCart",
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<CartItem>) => {
      const existingItem = state.items.find(
        (item) => item.productID === action.payload.productID
      );

      if (existingItem) {
        existingItem.quantity += action.payload.quantity;
      } else {
        state.items.push(action.payload);
      }

      // Save the updated cart to localStorage
      localStorage.setItem("guestCart", JSON.stringify(state.items));
    },
    updateCartQuantity: (
      state,
      action: PayloadAction<{ productID: string; quantity: number }>
    ) => {
      const existingItem = state.items.find(
        (item) => item.productID === action.payload.productID
      );

      if (existingItem) {
        existingItem.quantity = action.payload.quantity;

        // Save the updated cart to localStorage
        localStorage.setItem("guestCart", JSON.stringify(state.items));
      }
    },
    removeFromCart: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(
        (item) => item.productID !== action.payload
      );

      // Save the updated cart to localStorage
      localStorage.setItem("guestCart", JSON.stringify(state.items));
    },
    clearCart: (state) => {
      state.items = [];

      // Clear the cart from localStorage
      localStorage.removeItem("guestCart");
    },
  },
});

export const { addToCart, updateCartQuantity, removeFromCart, clearCart } =
  guestCartSlice.actions;

export const selectCartItems = (state: RootState) => state.guestCart.items;

export default guestCartSlice.reducer;
